import {get} from './request'
import {Page, PageRequest} from "@/model/Page";
import {News, NewsDetail} from "@/model/News";

const proxyUrl = process.env.VUE_APP_BASE_URL + '/news'

export interface NewsPageRequest extends PageRequest {
    sectionId: string,
}

export default {
    page: (data: NewsPageRequest): Promise<Page<News>> => get(`${proxyUrl}`, data),
    detail: (id: String): Promise<NewsDetail> => get(`${proxyUrl}/one?id=${id}`)
}
